import script from "./DownvoteAction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DownvoteAction.vue?vue&type=script&lang=js"
export * from "./DownvoteAction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DownvoteAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/story-page/DownvoteAction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5de7cfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5de7cfa', __exports__)) {
    api.reload('a5de7cfa', __exports__)
  }
  
}


export default __exports__